<template>
  <div>
    <v-btn
      v-if="params.data?.inscripcion?.programa?.programasModulos?.length > 0"
      class="mb-2"
      :title="tituloProgramaModulo"
      x-small
      outlined
      @click="mostrarModal">
      {{ textoProgramaModulo }}

      <v-icon small>mdi-information-outline</v-icon>
    </v-btn>

    <span v-else>-</span>

    <ModalModulos
      ref="modalModulosInscritosRef"
      :programasModulos="params.data?.inscripcion?.programa?.programasModulos" />
  </div>
</template>

<script>
import { obtenerModuloMasAlto } from '../utils/funciones';
import modalModulosMixin from '../mixins/boton-modulos.mixin';

export default {
  name: 'BotonModulos2',
  mixins: [modalModulosMixin],
  computed: {
    programaModuloMasAlto() {
      const programasModulos = this.params.data?.inscripcion?.programa?.programasModulos;

      return obtenerModuloMasAlto(programasModulos);
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>